export const state = () => ({
    selectAuthSignatory: {},
    Result:'',
    editAuthSignatory:{
        
    },
    birthCountryAuthSignatory: false

})  